export default "__VITE_ASSET__Ax_H0OYo__"